import styled from 'styled-components'

export const StyledContainer = styled.div`
	display: flex;
	position: relative;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 10px;
`

export const StyledLeftSide = styled.div`
	display: flex;
	flex-direction: column;
	width: 27%
`

export const StyledRightSide = styled.div`
	display: flex;
	flex-direction: column;
	width: 71%;
`


